import classNames from 'classnames'
import React from 'react'

import { CheckmarkCircleIcon, CrossIcon, InfoCircleIcon, WarningIcon } from 'components/ui/Icons'
import { ErrorType, AlertType, AlertLevels } from 'types'

const iconMap = {
  [AlertLevels.ERROR]: <WarningIcon />,
  [AlertLevels.WARNING]: <WarningIcon />,
  [AlertLevels.INFO]: <InfoCircleIcon />,
  [AlertLevels.SUCCESS]: <CheckmarkCircleIcon />,
}

/**
 * Convert any ErrorType error to an AlertType alert for use in Alert component
 */
function transformError(error: ErrorType): AlertType {
  let transformedError: AlertType
  switch (typeof error) {
    // Simple string is assumed to be an error message
    case 'string':
      transformedError = {
        level: AlertLevels.ERROR,
        message: error,
      }
      break
    // Javascript error objects and Alert objects
    case 'object':
      if (error !== null && (error instanceof Error || 'message' in (error as object))) {
        // Unpack message error object
        let {message} = error as Error
        if (typeof message !== 'string') {
          message = 'message' in message ? (message as Error).message : 'UNKNOWN_ERROR'
        }
        transformedError = {
          level: 'level' in (error as AlertType) ? (error as AlertType).level : AlertLevels.ERROR,
          message,
          data: error,
        }
      }
      break
    // Default to unknown error
    default:
      transformedError = {
        level: AlertLevels.ERROR,
        message: 'UNKNOWN_ERROR',
        data: error,
      }
  }
  return transformedError
}

export const Alert: React.FunctionComponent<AlertProps> = props => {
  const { style, alert, closable, onClose, className } = props
  const displayAlert = transformError(alert)
  const alertClasses = classNames(
    'Alert',
    alert ? null : 'Alert--hidden',
    alert && `Alert--${  displayAlert.level}`,
    className,
  )
  if (alert) {
    return (
      <div style={{...style}} className={alertClasses}>
        <div className="l-columns l-columns--align-start l-flex--all-sizes">
          <div className="Alert__icon-box l-flex--fixed">
            { iconMap[displayAlert.level] }
          </div>
          <div className="Alert__text l-flex">
            { displayAlert.message }
          </div>
          { closable &&
            <div className="Alert__close-icon u-clickable l-flex--fixed" onClick={onClose}>
              <CrossIcon />
            </div> }
        </div>
      </div>
    )
  } 
    return null
  
}

export type AlertProps = {
  className?: string,
  alert: ErrorType | null,
  closable?: boolean,
  onClose?: () => void,
  style?: {},
}

export default Alert